import { withCompController } from '@wix/editor-elements-integrations';
import type {
  TextEffectsSharedMapperProps,
  TextEffectsSharedStateValues,
} from '../TextEffectsShared.types';

export default withCompController<
  TextEffectsSharedMapperProps,
  TextEffectsSharedMapperProps & TextEffectsSharedStateValues,
  never,
  TextEffectsSharedStateValues
>(({ stateValues, mapperProps }) => {
  const reducedMotion =
    mapperProps.reducedMotionOverride !== undefined
      ? mapperProps.reducedMotionOverride
      : stateValues.reducedMotion;

  return { ...mapperProps, reducedMotion };
});
